import React from "react";
import "./Button.css";

const onMouseEnter = (event, color, bgColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

const onMouseOut = (event, color, bgColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

export default function Button({
  text,
  className,
  href,
  newTab,
  theme,
  bgColor,
  textColor,
  borderColor,
}) {
  const background = bgColor || theme.text;
  const foreground = textColor || theme.body;
  const border = borderColor || background;
  return (
    <div className={className}>
      <a
        class="main-button"
        href={href}
        target={newTab && "_blank"}
        style={{
          color: foreground,
          backgroundColor: background,
          border: `solid 1px ${border}`,
        }}
        onMouseEnter={(event) => onMouseEnter(event, background, foreground)}
        onMouseOut={(event) => onMouseOut(event, foreground, background)}
      >
        {text}
      </a>
    </div>
  );
}
